import { render, staticRenderFns } from "./gallery-overlay.global.vue?vue&type=template&id=50b125d4&"
import script from "./gallery-overlay.global.vue?vue&type=script&lang=js&"
export * from "./gallery-overlay.global.vue?vue&type=script&lang=js&"
import style0 from "./gallery-overlay.global.vue?vue&type=style&index=0&id=50b125d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports